import { render, staticRenderFns } from "./Joy.vue?vue&type=template&id=6c67e26a&"
import script from "./Joy.vue?vue&type=script&lang=js&"
export * from "./Joy.vue?vue&type=script&lang=js&"
import style0 from "./Joy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports